import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { parseString } from 'xml2js'

@Injectable({
  providedIn: 'root'
})
export class IconService {

  list:any[]
  constructor(
    private httpClient: HttpClient
  ) { }

  async initIconService() {
    try {
      const res = await this.httpClient.get("../../../assets/icon/iconsmind.svg", {
        headers: new HttpHeaders({
          "Accept": "image/svg+xml"
        }),
        responseType: "text"
      }).toPromise()
      /*
      let xml = parseString(res, (err,result) => {
        if(err) {
          console.log(err.message)
          return
        }
        this.list = result.svg.def[0].svg
      })
      */
    } catch (error) {
      console.log(error.message)
    }
  }

  getIcon(name: string) {
    return this.list.filter((i) => {
      return i.$.id == name
    })[0]
  }
}
